import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import KaraScanner from "./KaraScanner";

console.log("Kara AI ADVANCED TRADING CO PILOT: Initializing...");

try {
  const root = document.getElementById("root");
  if (!root) {
    console.error("Kara AI ADVANCED TRADING CO PILOT: Root element #root not found!");
  } else {
    createRoot(root).render(
      <StrictMode>
        <KaraScanner />
      </StrictMode>
    );
    console.log("Kara AI ADVANCED TRADING CO PILOT: Rendered.");
  }
} catch (err) {
  console.error("Kara AI ADVANCED TRADING CO PILOT: Initialization error", err);
}
